export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13712.ce0df5d9.jpg";